import React, { Component } from 'react';
import './css/index.scss';

// Router
import { Route, Switch } from 'react-router-dom';
import Header from './layout/Header';
import Footer from './layout/Footer';


// import Main from './layout/Main';
// import Work from './layout/Work';
// import View from './layout/View';

// 하나의 디렉토리에서 import 하기 위해 index.js 에서 export 설정 필요
import { Main, About, Work, Notice, Contact } from './layout';

// // projects import
// import { 
//   Project1, 
//   Project2, 
//   Project3, 
//   Project4, 
//   Project5, 
//   Project6, 
// } from './projects';


import Form from './js/form.js';


class App extends Component {

  componentDidMount(){
    // contact path 일때 FooterSimple로 보여주기

    // 공통으로 쓸 js 를 이렇게 불러도 되는지
      Form();
  }


  render() {
    return (
      <React.Fragment>
      <div id="container">
        <Header />

        <div className="inner">
            <Switch>
              <Route exact path="/" component={Main} />
              <Route path="/Work" component={Work} />
              <Route path="/About" component={About} />
              <Route path="/Notice" component={Notice} />
              <Route path="/Contact" component={Contact} />

              {/* <Route exact path={`${process.env.PUBLIC_URL}/`} component={Main} />
              <Route path={`${process.env.PUBLIC_URL}/Guide`} component={Guide} />
              <Route path={`${process.env.PUBLIC_URL}/Work`} component={Work} />
              <Route path={`${process.env.PUBLIC_URL}/Contact`} component={Contact} />
              <Route path={`${process.env.PUBLIC_URL}/Project1`} component={Project1} />
              <Route path={`${process.env.PUBLIC_URL}/Project2`} component={Project2} />
              <Route path={`${process.env.PUBLIC_URL}/Project3`} component={Project3} />
              <Route path={`${process.env.PUBLIC_URL}/Project4`} component={Project4} />
              <Route path={`${process.env.PUBLIC_URL}/Project5`} component={Project5} />
              <Route path={`${process.env.PUBLIC_URL}/Project6`} component={Project6} /> */}

            </Switch>

          </div>
          
          <Footer/>

      </div>
      </React.Fragment>
    );
  }
}

export default App;
